import './concept.css'

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
const header = document.querySelector('.site-header')
const menuToggle = document.querySelector('.menu-toggle')
const revealItems = document.querySelectorAll('.reveal')
const forestLayers = document.querySelectorAll('.forest-layer')
const portal = document.querySelector('.hero__portal')
const funnelStages = portal ? [...portal.querySelectorAll('[data-funnel-stage]')] : []
const spatialSections = document.querySelectorAll('[data-scene]')
const ambientRoots = document.querySelector('.ambient__roots')

const year = document.querySelector('#year')
if (year) year.textContent = String(new Date().getFullYear())

if (menuToggle instanceof HTMLButtonElement && header) {
  menuToggle.addEventListener('click', () => {
    const open = header.classList.toggle('is-open')
    menuToggle.setAttribute('aria-expanded', String(open))
  })

  header.querySelectorAll('nav a').forEach((link) => {
    link.addEventListener('click', () => {
      header.classList.remove('is-open')
      menuToggle.setAttribute('aria-expanded', 'false')
    })
  })
}

if (portal instanceof HTMLElement && funnelStages.length > 0) {
  let activeFunnelStage = 0
  const showFunnelStage = (index) => {
    activeFunnelStage = index % funnelStages.length
    portal.dataset.stage = String(activeFunnelStage)
    funnelStages.forEach((stage, stageIndex) => stage.classList.toggle('is-active', stageIndex === activeFunnelStage))
  }
  showFunnelStage(0)
  if (!reducedMotion) window.setInterval(() => showFunnelStage(activeFunnelStage + 1), 2200)
}

if (reducedMotion) {
  revealItems.forEach((item) => item.classList.add('is-visible'))
} else if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add('is-visible')
        revealObserver.unobserve(entry.target)
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
  )
  revealItems.forEach((item) => revealObserver.observe(item))
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'))
}

if (!reducedMotion) {
  let frameRequested = false

  const updateDepth = () => {
    frameRequested = false
    const scrollY = window.scrollY
    forestLayers.forEach((layer, index) => {
      const distance = (index + 1) * 0.035
      layer.style.translate = `0 ${scrollY * distance}px`
    })
    if (portal instanceof HTMLElement) {
      const progress = Math.min(scrollY / Math.max(window.innerHeight, 1), 1)
      portal.style.translate = `0 ${progress * 80}px`
      portal.style.opacity = String(1 - progress * 0.72)
    }
    if (ambientRoots instanceof SVGElement) {
      ambientRoots.style.translate = `0 ${scrollY * -0.018}px`
    }
  }

  window.addEventListener('scroll', () => {
    if (frameRequested) return
    frameRequested = true
    requestAnimationFrame(updateDepth)
  }, { passive: true })
  updateDepth()

  document.querySelector('.hero')?.addEventListener('pointermove', (event) => {
    if (!(event.currentTarget instanceof HTMLElement) || !(portal instanceof HTMLElement)) return
    const rect = event.currentTarget.getBoundingClientRect()
    const x = (event.clientX - rect.left) / rect.width - 0.5
    const y = (event.clientY - rect.top) / rect.height - 0.5
    portal.style.transform = `translate(${x * 14}px, ${y * 14}px)`
  })
}

if ('IntersectionObserver' in window) {
  const sceneObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-depth-active', entry.isIntersecting)
        if (entry.isIntersecting) document.body.dataset.scene = entry.target.dataset.scene || ''
      })
    },
    { threshold: 0.12, rootMargin: '-12% 0px -12% 0px' },
  )
  spatialSections.forEach((section) => sceneObserver.observe(section))
} else {
  spatialSections.forEach((section) => section.classList.add('is-depth-active'))
}

const contactForm = document.querySelector('#concept-contact')
const contactStatus = document.querySelector('#concept-status')

if (contactForm instanceof HTMLFormElement && contactStatus) {
  const quizSteps = [...contactForm.querySelectorAll('.quiz-step')]
  const backButton = contactForm.querySelector('#concept-back')
  const nextButton = contactForm.querySelector('#concept-next')
  const submitButton = contactForm.querySelector('#concept-submit')
  const progressLabel = contactForm.querySelector('#concept-progress-label')
  const progressName = contactForm.querySelector('#concept-progress-name')
  const progressFill = contactForm.querySelector('#concept-progress-fill')
  const focusLabel = contactForm.querySelector('#concept-focus-label')
  const branchSets = [...contactForm.querySelectorAll('.quiz-branch-set')]
  const fields = {
    bottleneck: contactForm.querySelector('#concept-bottleneck'),
    focus: contactForm.querySelector('#concept-focus'),
    goal: contactForm.querySelector('#concept-goal'),
  }
  const stepNames = ['Find the friction', 'Define the outcome', 'Make the connection']
  let currentStep = 1

  const selectOption = (field, value) => {
    contactForm.querySelectorAll(`.quiz-option[data-field="${field}"]`).forEach((option) => {
      option.classList.toggle('is-selected', option.dataset.value === value)
      option.setAttribute('aria-checked', String(option.dataset.value === value))
    })
  }

  const setBranch = () => {
    const bottleneck = fields.bottleneck instanceof HTMLInputElement ? fields.bottleneck.value : ''
    const branch = /seo/i.test(bottleneck) ? 'seo' : 'default'
    if (focusLabel) {
      focusLabel.textContent = branch === 'seo'
        ? 'Which SEO outcome matters most in the next 90 days?'
        : 'Which result matters most in the next 90 days?'
    }

    let activeValues = []
    branchSets.forEach((set) => {
      const active = set.dataset.branch === branch
      set.hidden = !active
      if (active) {
        activeValues = [...set.querySelectorAll('.quiz-option')].map((option) => option.dataset.value || '')
      }
    })

    if (fields.focus instanceof HTMLInputElement && !activeValues.includes(fields.focus.value)) {
      fields.focus.value = ''
      selectOption('focus', '')
    }
  }

  const setStep = (step) => {
    currentStep = Math.min(Math.max(step, 1), quizSteps.length)
    quizSteps.forEach((item) => item.classList.toggle('is-active', Number(item.dataset.step) === currentStep))
    if (backButton instanceof HTMLButtonElement) backButton.hidden = currentStep === 1
    if (nextButton instanceof HTMLButtonElement) nextButton.hidden = currentStep === quizSteps.length
    if (submitButton instanceof HTMLButtonElement) submitButton.hidden = currentStep !== quizSteps.length
    if (progressLabel) progressLabel.textContent = `Step ${currentStep} of ${quizSteps.length}`
    if (progressName) progressName.textContent = stepNames[currentStep - 1]
    if (progressFill instanceof HTMLElement) progressFill.style.width = `${(currentStep / quizSteps.length) * 100}%`
    if (currentStep === 2) setBranch()
    contactStatus.textContent = ''
    contactStatus.dataset.state = ''
  }

  const validateStep = (step) => {
    const data = new FormData(contactForm)
    const bottleneck = String(data.get('bottleneck') || '').trim()
    const focus = String(data.get('focus') || '').trim()
    const goal = String(data.get('goal') || '').trim()
    const name = String(data.get('name') || '').trim()
    const email = String(data.get('email') || '').trim()

    if (step === 1 && !bottleneck) {
      contactStatus.textContent = 'Choose the bottleneck that feels most urgent.'
    } else if (step === 2 && !focus) {
      contactStatus.textContent = 'Choose the outcome that matters most.'
    } else if (step === 3 && !goal) {
      contactStatus.textContent = 'Choose your monthly lead goal.'
    } else if (step === 3 && (!name || !email)) {
      contactStatus.textContent = 'Please add your name and work email.'
    } else {
      contactStatus.textContent = ''
      contactStatus.dataset.state = ''
      return true
    }

    contactStatus.dataset.state = 'error'
    return false
  }

  contactForm.querySelectorAll('.quiz-option').forEach((option) => {
    option.setAttribute('role', 'radio')
    option.setAttribute('aria-checked', 'false')
    option.addEventListener('click', () => {
      const field = option.dataset.field || ''
      const value = option.dataset.value || ''
      const input = fields[field]
      if (!(input instanceof HTMLInputElement) || !value) return
      input.value = value
      selectOption(field, value)
      if (field === 'bottleneck') setBranch()
      contactStatus.textContent = ''
      contactStatus.dataset.state = ''
    })
  })

  if (nextButton instanceof HTMLButtonElement) {
    nextButton.addEventListener('click', () => {
      if (validateStep(currentStep)) setStep(currentStep + 1)
    })
  }

  if (backButton instanceof HTMLButtonElement) {
    backButton.addEventListener('click', () => setStep(currentStep - 1))
  }

  setStep(1)
  setBranch()

  contactForm.addEventListener('submit', async (event) => {
    event.preventDefault()
    if (!validateStep(3)) return

    const data = new FormData(contactForm)
    const name = String(data.get('name') || '').trim()
    const email = String(data.get('email') || '').trim()
    const context = String(data.get('message') || '').trim()
    const bottleneck = String(data.get('bottleneck') || '').trim()
    const focus = String(data.get('focus') || '').trim()
    const goal = String(data.get('goal') || '').trim()
    const message = [
      'Website inquiry',
      `Primary bottleneck: ${bottleneck}`,
      `Priority outcome: ${focus}`,
      `Monthly lead goal: ${goal}`,
      context ? `Context: ${context}` : '',
    ].filter(Boolean).join('\n')

    if (submitButton instanceof HTMLButtonElement) submitButton.disabled = true
    contactStatus.textContent = 'Mapping your request...'
    contactStatus.dataset.state = 'pending'

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ name, email, message }),
      })
      if (!response.ok) throw new Error(`Request failed (${response.status})`)
      contactForm.reset()
      contactForm.querySelectorAll('.quiz-option').forEach((option) => {
        option.classList.remove('is-selected')
        option.setAttribute('aria-checked', 'false')
      })
      setStep(1)
      setBranch()
      contactStatus.textContent = 'Received. We’ll be in touch shortly.'
      contactStatus.dataset.state = 'ok'
    } catch {
      contactStatus.textContent = 'Could not send right now. Please email contact@decentralogix.com.'
      contactStatus.dataset.state = 'error'
    } finally {
      if (submitButton instanceof HTMLButtonElement) submitButton.disabled = false
    }
  })
}

const chatToggle = document.querySelector('#ai-chat-toggle')
const chatPanel = document.querySelector('#ai-chatbot')
const chatMinimize = document.querySelector('#ai-chat-minimize')
const chatMini = document.querySelector('#ai-chat-mini')
const chatLog = document.querySelector('#ai-chat-log')
const chatForm = document.querySelector('#ai-chat-form')
const chatInput = document.querySelector('#ai-chat-input')
const chatSend = document.querySelector('#ai-chat-send')
const chatHistory = []
let pendingReply = false
let hasBeenMinimized = false

function newSessionId() {
  return globalThis.crypto && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `sess-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

let chatSessionId = newSessionId()

function chatbotFailureMessage(errorCode, requestId) {
  const ref = requestId ? ` Ref ${requestId}.` : ''
  if (errorCode === 'chatbot-timeout') return `Deep thinking is taking longer than expected.${ref} I am keeping this session active.`
  if (errorCode === 'chatbot-upstream-error') return `I hit a model-side hiccup.${ref} I am still here with your current session context.`
  if (errorCode === 'chatbot-query-failed') return `I hit a runtime hiccup.${ref} Session context is still intact.`
  if (errorCode === 'network-error') return `Network link was unstable for a moment.${ref} Your session is still active.`
  return `I could not finish that response yet.${ref} Your session is still active.`
}

function isRetryableChatError(errorCode) {
  return errorCode === 'chatbot-timeout'
    || errorCode === 'chatbot-upstream-error'
    || errorCode === 'chatbot-query-failed'
    || errorCode === 'network-error'
}

function deriveChatErrorCode(error) {
  const payloadCode = String(error?.payload?.error || '').trim()
  if (payloadCode) return payloadCode
  const status = Number(error?.status || 0)
  if (status === 504) return 'chatbot-timeout'
  if (status === 502) return 'chatbot-upstream-error'
  if (error?.name === 'TypeError') return 'network-error'
  return ''
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

async function requestAssistantReply(message, turnId, onRetry) {
  const maxAttempts = 3
  let lastError = null
  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    let payload = {}
    try {
      const response = await fetch('/api/chatbot', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'x-chat-session-id': chatSessionId,
        },
        body: JSON.stringify({
          message,
          history: chatHistory.slice(-10),
          session_id: chatSessionId,
          turn_id: turnId,
        }),
      })
      try {
        payload = await response.json()
      } catch {
        payload = {}
      }
      if (!response.ok) {
        const error = new Error(`chatbot-error-${response.status}`)
        error.payload = payload
        error.status = response.status
        throw error
      }
      return payload
    } catch (error) {
      lastError = error
      const errorCode = deriveChatErrorCode(error)
      if (!isRetryableChatError(errorCode) || attempt >= maxAttempts) throw error
      if (typeof onRetry === 'function') {
        onRetry({ attempt, errorCode, requestId: String(error?.payload?.request_id || '') })
      }
      await wait(1200 * attempt)
    }
  }
  throw lastError || new Error('chatbot-retry-failed')
}

function appendChatBubble(role, content, pending = false) {
  if (!chatLog) return null
  const row = document.createElement('div')
  row.className = `ai-row ${role}${pending ? ' pending' : ''}`
  const bubble = document.createElement('div')
  bubble.className = 'ai-bubble'
  bubble.textContent = content
  row.appendChild(bubble)
  chatLog.appendChild(row)
  chatLog.scrollTop = chatLog.scrollHeight
  return row
}

function openChat() {
  if (!(chatPanel instanceof HTMLElement && chatToggle instanceof HTMLButtonElement)) return
  chatPanel.hidden = false
  if (chatMini instanceof HTMLButtonElement) chatMini.hidden = true
  chatToggle.setAttribute('aria-expanded', 'true')
  window.setTimeout(() => {
    if (chatInput instanceof HTMLInputElement) chatInput.focus()
  }, 40)
}

function minimizeChatPanel() {
  if (!(chatPanel instanceof HTMLElement && chatToggle instanceof HTMLButtonElement)) return
  hasBeenMinimized = true
  chatPanel.hidden = true
  if (chatMini instanceof HTMLButtonElement) chatMini.hidden = false
  chatToggle.setAttribute('aria-expanded', 'false')
}

if (chatLog) {
  appendChatBubble('assistant', 'Hey, I am the Decentralogix assistant. Ask me about services, implementation scope, or project fit.')
}

if (chatToggle instanceof HTMLButtonElement) {
  chatToggle.addEventListener('click', () => {
    const hidden = chatPanel instanceof HTMLElement ? chatPanel.hidden : true
    if (hidden) openChat()
    else minimizeChatPanel()
  })
}

if (chatMinimize instanceof HTMLButtonElement) chatMinimize.addEventListener('click', minimizeChatPanel)

if (chatMini instanceof HTMLButtonElement) {
  chatMini.hidden = !hasBeenMinimized
  chatMini.addEventListener('click', openChat)
}

if (chatForm instanceof HTMLFormElement && chatInput instanceof HTMLInputElement && chatSend instanceof HTMLButtonElement) {
  chatForm.addEventListener('submit', async (event) => {
    event.preventDefault()
    if (pendingReply) return
    const message = chatInput.value.trim()
    if (!message) return

    openChat()
    chatHistory.push({ role: 'user', content: message })
    appendChatBubble('user', message)
    chatInput.value = ''
    pendingReply = true
    chatInput.disabled = true
    chatSend.disabled = true
    const typingBubble = appendChatBubble('assistant', 'Thinking...', true)

    try {
      const turnId = newSessionId()
      const payload = await requestAssistantReply(message, turnId, () => {
        const bubble = typingBubble?.querySelector('.ai-bubble')
        if (bubble) bubble.textContent = 'Deep thinking — thank you for your patience...'
      })
      if (typeof payload.session_id === 'string' && payload.session_id.trim()) {
        chatSessionId = payload.session_id.trim().slice(0, 120)
      }
      const answer = String(payload.answer || '').trim() || 'I could not find a confident answer yet.'
      if (typingBubble) typingBubble.remove()
      appendChatBubble('assistant', answer)
      chatHistory.push({ role: 'assistant', content: answer })
    } catch (error) {
      if (typingBubble) typingBubble.remove()
      const errorCode = deriveChatErrorCode(error)
      const requestId = String(error?.payload?.request_id || '')
      appendChatBubble('assistant', chatbotFailureMessage(errorCode, requestId))
    } finally {
      pendingReply = false
      chatInput.disabled = false
      chatSend.disabled = false
      chatInput.focus()
    }
  })
}
